import { NavigationModule } from '@progress/kendo-angular-navigation';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ToolBarModule } from '@progress/kendo-angular-toolbar';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { IconsModule } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { PopupModule } from '@progress/kendo-angular-popup';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { CustomerCommunicationFormDrawerModule } from '@app/shared/components/drawer-forms';

import { SharedModule } from '../shared/shared.module';
import { ShellComponent } from './shell/shell.component';
import { UserDropdownComponent } from './user-dropdown/user-dropdown.component';
import { HelpDrawerComponent } from './help/help-drawer.component';
import { MessagesDrawerComponent } from './messages/messages-drawer.component';

@NgModule({
    declarations: [ShellComponent, UserDropdownComponent, HelpDrawerComponent, MessagesDrawerComponent],
    imports: [
        CommonModule,
        ToolBarModule,
        LayoutModule,
        FlexLayoutModule,
        IndicatorsModule,
        IconsModule,
        NavigationModule,
        ButtonsModule,
        SharedModule,
        PopupModule,
        RouterModule.forChild([
            { path: 'shell', component: ShellComponent }
        ]),

        CustomerCommunicationFormDrawerModule
    ]
})
export class ShellModule { }
